import i18n from "@i18n";

export const initNavigationArrows = (lightbox, disable_arrows_on_mobile) => {
    lightbox.on('uiRegister', () => {

        setTimeout(() => {
            const arrowPrevButton = lightbox.pswp.element.querySelector('.pswp__button--arrow--prev');
            const arrowNextButton = lightbox.pswp.element.querySelector('.pswp__button--arrow--next');

            //Set Aria labels for accessibility
            if (arrowPrevButton) {
                arrowPrevButton.setAttribute('aria-label', i18n.TOOLBAR.PREVIOUS);
                arrowPrevButton.removeAttribute('title');
            }
            if (arrowNextButton) {
                arrowNextButton.setAttribute('aria-label', i18n.TOOLBAR.NEXT);
                arrowNextButton.removeAttribute('title');
            }

            const isMobileAgent = /Mobi|Android/i.test(navigator.userAgent);
            const isMobileMedia = window.matchMedia("(max-width: 820px)").matches;

            const isMobile = isMobileAgent || isMobileMedia;

            if ( isMobile && disable_arrows_on_mobile ) {
                arrowPrevButton.classList.add('mwl__nav-arrow-not-visible');
                arrowNextButton.classList.add('mwl__nav-arrow-not-visible');

                return;
            }

            //Always show arrows on desktop
            arrowPrevButton.classList.add('mwl__nav-arrow-visible');
            arrowNextButton.classList.add('mwl__nav-arrow-visible');

        }, 0);

    });
};